const DOM_MUTATION_ERROR_PATTERN =
  /failed to execute '(removeChild|insertBefore|replaceChild)' on 'Node'/i;

export const isRecoverableDomMutationMessage = (value: unknown): boolean => {
  if (typeof value !== 'string' || value.length === 0) {
    return false;
  }

  return DOM_MUTATION_ERROR_PATTERN.test(value);
};

export const isRecoverableDomMutationError = (error: unknown): boolean => {
  if (typeof error === 'string') {
    return isRecoverableDomMutationMessage(error);
  }

  if (!error || typeof error !== 'object') {
    return false;
  }

  const candidate = error as { message?: string; stack?: string; name?: string };

  return (
    isRecoverableDomMutationMessage(candidate.message) ||
    isRecoverableDomMutationMessage(candidate.stack) ||
    (candidate.name === 'NotFoundError' &&
      isRecoverableDomMutationMessage(candidate.message))
  );
};

interface RumErrorEventShape {
  type: string;
  error?: {
    message?: string;
    stack?: string;
    type?: string;
    source?: string;
  };
}

export const shouldDiscardRumErrorEvent = (event: RumErrorEventShape): boolean => {
  if (event.type !== 'error' || !event.error) {
    return false;
  }

  const { message, stack, type } = event.error;

  return (
    isRecoverableDomMutationMessage(message) ||
    isRecoverableDomMutationMessage(stack) ||
    (type === 'NotFoundError' && isRecoverableDomMutationMessage(message))
  );
};
